import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-horizontal-chart',
	templateUrl: './horizontal-chart.component.html',
	styleUrls: ['./horizontal-chart.component.css']
})
export class HorizontalChartComponent {
	@Input() title: any = {};
	@Input() devices: any = [];
	@Input() data: any = [];
	@Input() vAxisTitle: string = this.translate.instant('g.device');
	@Input() chartMaxValue: number = 100;
	chartHeight: number = 200;
	showAll = false;
	showChart = false;

	chart = {
		title: this.translate.instant('g.utilization_percentage'),
		data: [],
		shownData: [],
		columnNames: [this.translate.instant('g.device'), this.translate.instant('g.usage_percentage'), { role: 'annotation' }],
		config: {
			hAxis: {
				title: this.translate.instant('g.usage_percentage'),
				viewWindow: {
					min: 0,
					max: 100
				}
			},
			vAxis: {
				title: this.translate.instant('g.device'),
			},
			colors: ['red'],
			legend: 'none',
			titleTextStyle: {
				fontSize: 16,
				bold: true,
				color: '#333',
				paddingBottom: 20,
				paddingTop: 20
			},
			bar: {
				groupWidth: '25px'
			},
			chartArea: {
				top: 40,
				bottom: 40,
				height: '100%'
			},
			annotations: {
				textStyle: {
					fontSize: 14,
					color: 'black'
				}
			},
		}
	}

	constructor(private translate: TranslateService) { }

	ngOnInit() {
		this.chart.title = this.title;
		this.chart.config.vAxis.title = this.vAxisTitle;
		this.chart.config.hAxis.viewWindow.max = this.chartMaxValue;

		this.formatSelectedData();
	}

	ngOnChanges() {
		this.formatSelectedData();
	}

	formatSelectedData() {
		if (!this.data || !Object.keys(this.devices).length)
			return;

		const scoresData = this.data || [];
		if (!scoresData.length)
			return;

		const data = [];
		for (const deviceScore of scoresData) {
			const mac = deviceScore.macAddress;
			const name = this.devices[mac]?.truck_id || this.devices[mac]?.serial_number;
			if (!name)
				continue;

			data.push([name, deviceScore.score, (deviceScore.score || 0).toFixed(2) + '%']);
			this.showChart = true;
		}

		// sort the data by score in descending order
		data.sort((a, b) => {
			const scoreA = parseFloat(a[1]);
			const scoreB = parseFloat(b[1]);
			return scoreB - scoreA; // descending order
		});

		this.chart.data = data;
		this.updateShownData();
		this.updateChartHeight();
	}

	toggleShowAll() {
		this.showAll = !this.showAll;
		this.updateShownData();
		this.updateChartHeight();
	}

	updateChartHeight() {
		if (this.showAll)
			return this.chartHeight = 200 + (this.chart.data.length > 3 ? this.chart.data.length - 3 : 0) * 25; // adding 25px for each extra row above 3 rows

		this.chartHeight = this.chart.data.length > 5 ? 400 : 200;
	}

	updateShownData() {
		this.chart.shownData = this.showAll ? this.chart.data : this.chart.data.slice(0, 10);
	}
}
